function age_groups_for(tour, adults, ages){
  if (tour === undefined) return false;

  let data,
      kids = 0,
      babies = 0;
  if (ages === undefined) ages = [];
  // data = correct_adults(tour, adults, ages);
  // adults = data[0];
  // ages = data[1];
  console.log('ages:',ages)
  ages.forEach((age)=>{
    if (is_adult(tour, age)) adults += 1;
    if (is_kid(tour, age)) kids += 1;
    if (is_baby(tour, age)) babies += 1;
  })

  return {
    adults: adults,
    kids:   kids,
    babies: babies,
  }
}

function is_adult(tour, age){
  return (!is_baby(tour, age) && !is_kid(tour, age))
}

function is_kid(tour, age){
  return ((Number(age) < tour.kid_age) && !is_baby(tour, age))
}

function is_baby(tour, age){
  return Number(age) < tour.baby_age
}

function is_correct_ages(tour, ages){
  if (ages === undefined) return true;
  let flag = true
  ages.forEach((age)=>{
     if (Number(age) < tour.min_age) flag = false
  })
  return flag;
}


function correct_adults(tour, adults, ages){
  if (ages === undefined) return [adults, ages]
  let new_ages = [];
  adults = Number(adults);
  ages.map((el)=>{return Number(el)}).forEach((age)=>{
    if (age < tour.kid_age) {
      new_ages.push(age);
    } else {
      adults += 1;
    }
  });
  return [adults, new_ages]
}

export {
  age_groups_for,
}